import r from"./classApplyDescriptorGet.js";import t from"./classExtractFieldDescriptor.js";function s(s,e){var o=t(s,e,"get");return r(s,o)}export{s as default};
